// Shared course chapter renderer for the candidate view and editorial preview.
// Escape all imported/editor-authored text before interpolating into HTML.
export function escapeCourseText(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function items(value) {
  return Array.isArray(value) ? value : [];
}

function paragraphs(value) {
  return String(value || '')
    .split(/\n\s*\n/)
    .filter((text) => text.trim())
    .map((text) =>
      `<p style="margin-bottom:15px;line-height:1.6;">${escapeCourseText(text).replace(/\n/g, '<br />')}</p>`
    )
    .join('');
}

function bulletList(value) {
  return items(value)
    .map((entry) => `<li style="margin-bottom:5px;">${escapeCourseText(entry)}</li>`)
    .join('');
}

export function generateHtmlFromChapitre(chapitre = {}) {
  let html = `<h2>${escapeCourseText(chapitre.titre)}</h2>`;
  if (chapitre.objectif) {
    html += `<p style="font-size:1.1em;color:#4b5563;margin-bottom:20px;"><strong>Objectif du chapitre :</strong> ${escapeCourseText(chapitre.objectif)}</p>`;
  }
  for (const section of items(chapitre.sections)) {
    html += '<hr style="margin:30px 0;border:0;border-top:1px solid #e2e8f0;" />';
    html += `<h3 style="color:#1e3a8a;font-size:1.5em;font-weight:bold;margin-bottom:10px;">${escapeCourseText(section.titre)}</h3>`;
    if (section.objectif_pedagogique) {
      html += `<p style="color:#6b7280;font-style:italic;margin-bottom:15px;">Objectif : ${escapeCourseText(section.objectif_pedagogique)}</p>`;
    }
    html += paragraphs(section.contenu);
    if (items(section.notions_cles).length) {
      html += `<p style="margin-top:15px;"><strong>Notions clés :</strong> ${items(section.notions_cles).map((v) => `<span style="background:#f3f4f6;padding:2px 8px;border-radius:4px;color:#374151;">${escapeCourseText(v)}</span>`).join(' ')}</p>`;
    }
    if (items(section.exemples_courts).length) {
      html += `<div style="background:#f8fafc;border-left:4px solid #3b82f6;padding:15px;margin:20px 0;border-radius:8px;"><strong style="color:#2563eb;">💡 Exemples :</strong><ul style="padding-left:20px;">${bulletList(section.exemples_courts)}</ul></div>`;
    }
    if (items(section.a_retenir).length) {
      html += `<div style="background:#f0fdf4;border-left:4px solid #22c55e;padding:15px;margin:20px 0;border-radius:8px;"><strong style="color:#16a34a;">📌 À retenir :</strong><ul style="padding-left:20px;">${bulletList(section.a_retenir)}</ul></div>`;
    }
    if (items(section.vigilances).length) {
      html += `<div style="background:#fef2f2;border-left:4px solid #ef4444;padding:15px;margin:20px 0;border-radius:8px;color:#991b1b;"><strong style="color:#dc2626;">⚠️ Attention / Vigilance :</strong><ul style="padding-left:20px;">${bulletList(section.vigilances)}</ul></div>`;
    }
  }
  return html;
}
